import React from "react"
import { useValueNullificationOnUnmount } from "source/people/components/hooks/useValueNulificationOnUnmount"
import PropTypes from "prop-types"
import {
  CheckboxGroup,
  CheckboxProminent,
  Description,
  Field,
  FieldGroup,
  Select,
} from "source/people/components/ui"

const WorkflowCheckboxField = ({
  onChange,
  id,
  attributes,
  options,
  errors,
  value,
  ...props
}) => {
  const { label, description } = attributes
  const option = options[0]

  useValueNullificationOnUnmount({ onChange, id, value })

  return (
    <Field
      {...props}
      id={id}
      key={id}
      errors={errors}
      {...attributes}
      noLabel={true}
    >
      <div>
        <FieldGroup>
          <CheckboxProminent
            errors={errors}
            key={option.id}
            label={label}
            id={`checkbox_${option.id}`}
            required={attributes.required}
            onChange={(e) => onChange(e.target.checked && option.id, id)}
          />
        </FieldGroup>
      </div>
      <div className="ml-3">
        <Description description={description} />
      </div>
    </Field>
  )
}

WorkflowCheckboxField.propTypes = {
  onChange: PropTypes.func,
  id: PropTypes.any,
  attributes: PropTypes.object,
  options: PropTypes.array,
  errors: PropTypes.any,
  value: PropTypes.any,
}

const WorkflowCheckboxesField = ({
  onChange,
  id,
  attributes,
  options,
  errors,
  otherOption,
  otherOptionWithNoWorkflow,
  value,
  ...props
}) => {
  useValueNullificationOnUnmount({ onChange, id, value })

  const { description } = attributes

  return (
    <Field
      {...props}
      id={id}
      key={id}
      errors={errors}
      {...attributes}
      noLabel={false}
    >
      <Description description={description} />
      <CheckboxGroup
        id={id}
        errors={errors}
        options={options}
        onChange={(value) => onChange(value, id)}
        hasOtherOption={!!(otherOption?.data) || otherOptionWithNoWorkflow}
      />
    </Field>
  )
}

WorkflowCheckboxesField.propTypes = {
  onChange: PropTypes.func,
  id: PropTypes.any,
  attributes: PropTypes.object,
  options: PropTypes.array,
  errors: PropTypes.any,
  otherOption: PropTypes.any,
  otherOptionWithNoWorkflow: PropTypes.any,
  value: PropTypes.any,
}

const WorkflowDropdownField = ({
  onChange,
  id,
  attributes,
  options,
  errors,
  otherOption,
  otherOptionWithNoWorkflow,
  value,
  ...props
}) => {
  useValueNullificationOnUnmount({ onChange, id, value })

  const { description } = attributes

  return (
    <Field
      {...props}
      id={id}
      key={id}
      errors={errors}
      {...attributes}
      noLabel={false}
    >
      <Description description={description} />
      <Select
        errors={errors}
        hasOtherOption={!!(otherOption?.data) || otherOptionWithNoWorkflow}
        id={`workflow_dropdown_${id}`}
        onChange={(value) => onChange(value, id)}
      >
        {options
          .sort((a, b) => a.attributes.sequence - b.attributes.sequence)
          .map((o) => (
            <option key={o.id} value={o.id}>
              {o.attributes.label}
            </option>
          ))}
      </Select>
    </Field>
  )
}

WorkflowDropdownField.propTypes = {
  onChange: PropTypes.func,
  id: PropTypes.any,
  attributes: PropTypes.object,
  options: PropTypes.any,
  errors: PropTypes.any,
  otherOption: PropTypes.any,
  otherOptionWithNoWorkflow: PropTypes.any,
  value: PropTypes.any,
}

export { WorkflowCheckboxField, WorkflowCheckboxesField, WorkflowDropdownField }
